var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feedback",
    transform: "translate(-510 -428)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 72,
    height: 72,
    rx: 12,
    transform: "translate(510 428)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "feedback_icon",
    "data-name": "feedback icon",
    transform: "translate(521.077 440)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 48,
    height: 48,
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(9.333 6.667)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 30.297,
    height: 26.801,
    rx: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_41_-_Outline",
    "data-name": "Rectangle 41 - Outline",
    d: "M3.5,1.748A1.75,1.75,0,0,0,1.748,3.5v19.81A1.75,1.75,0,0,0,3.5,25.053H26.8a1.75,1.75,0,0,0,1.748-1.748V3.5A1.75,1.75,0,0,0,26.8,1.748H3.5M3.5,0H26.8a3.5,3.5,0,0,1,3.5,3.5v19.81a3.5,3.5,0,0,1-3.5,3.5H3.5a3.5,3.5,0,0,1-3.5-3.5V3.5A3.5,3.5,0,0,1,3.5,0Z",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_24",
    "data-name": "Line 24",
    d: "M15.272,1H.124a.874.874,0,1,1,0-1.748H15.272a.874.874,0,0,1,0,1.748Z",
    transform: "translate(7.45 5.702)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_25",
    "data-name": "Line 25",
    d: "M15.272,1H.124a.874.874,0,1,1,0-1.748H15.272a.874.874,0,0,1,0,1.748Z",
    transform: "translate(7.45 10.363)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_26",
    "data-name": "Line 26",
    d: "M9.875,1H-.17C-.491,1-.75.607-.75.124S-.491-.75-.17-.75H9.875c.32,0,.58.391.58.874S10.195,1,9.875,1Z",
    transform: "translate(7.45 15.025)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_27",
    "data-name": "Line 27",
    d: "M15.272,1H.124a.874.874,0,1,1,0-1.748H15.272a.874.874,0,0,1,0,1.748Z",
    transform: "translate(7.45 19.686)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 8.157,
    height: 3.496,
    transform: "translate(11.653 24.471)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M-1487.736,2718.423a.864.864,0,0,1-.342-.068.874.874,0,0,1-.532-.8v-7.881a.873.873,0,0,1,.875-.875.873.873,0,0,1,.873.875v5.821l6.677-6.449a.872.872,0,0,1,1.236.021.874.874,0,0,1-.022,1.236l-8.157,7.883A.883.883,0,0,1-1487.736,2718.423Z",
    transform: "translate(1499.389 -2683.757)",
    fill: "#19bc9c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.76a74b5ec145b4515657404284539928.svg";
export { ForwardRef as ReactComponent };